import { Button } from "@/components/kit";
import { Icon } from "@/lib/icons";

const money = (c) => `$${((c || 0) / 100).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
const oneLine = (s) => {
  const t = (s || "").replace(/<[^>]+>/g, "").trim();
  return t.length > 130 ? `${t.slice(0, 127)}…` : t;
};

// Presentational campaign card for the give list and dashboards. No donor names.
export default function GiveCard({ c, variant = "full", onGive }) {
  const label = c.give_label || c.title;
  const showProg = c.show_progress && !c.is_default && c.raised_cents != null;
  const pct = c.goal_cents ? Math.min(100, Math.round((c.raised_cents / c.goal_cents) * 100)) : 100;
  const compact = variant === "compact";
  return (
    <div data-testid={`give-card-${c.campaign_id}`} className="bg-cream border border-ink/15 rounded-xl overflow-hidden flex flex-col">
      {c.cover_image
        ? <img src={c.cover_image} alt="" className={`w-full object-cover ${compact ? "h-24" : "h-40"}`} />
        : <div className={`w-full bg-dark-olive/10 flex items-center justify-center ${compact ? "h-20" : "h-28"}`}><Icon name="HeartHandshake" className="w-8 h-8 text-dark-olive/40" /></div>}
      <div className="p-4 flex-1 flex flex-col">
        <div className="font-semibold text-[15px]">{label}</div>
        <p className={`text-ink/60 mt-1 flex-1 ${compact ? "text-[12px] truncate" : "text-[13px]"}`}>{oneLine(c.story) || "Support Rosemoor."}</p>
        {showProg && (
          <div className="mt-2">
            <div className="h-2 rounded-full bg-ink/10 overflow-hidden"><div className="h-full bg-dark-olive rounded-full" style={{ width: `${pct}%` }} /></div>
            <div className="text-[12px] text-ink/55 mt-1">{money(c.raised_cents)} raised{c.goal_cents ? ` of ${money(c.goal_cents)}` : ""} · {c.gift_count} gift{c.gift_count === 1 ? "" : "s"}</div>
          </div>
        )}
        <Button data-testid={`give-btn-${c.campaign_id}`} onClick={() => onGive(c)} className="mt-3 w-full"><Icon name="HeartHandshake" className="w-4 h-4" /> Give</Button>
      </div>
    </div>
  );
}
